import { Link } from "react-router-dom";
import Container from "../../components/Container";
import CartItem from "./CartItem";
import Summary from "./Summary";

const Cart = () => {
  return (
    <section className="bg-white">
      <Container>
        <div className="flex xs:flex-col lg:flex-row">
          <div className="px-4 xs:w-full lg:w-8/12">
            <div className="title border-b pb-4 font-medium text-[23px]">
              <h1>Shopping Cart</h1>
            </div>
            <div className="cart-items">
              <ul>
                {Array(4)
                  .fill(true)
                  .map((item, index) => {
                    return (
                      <li className="border-b lg:last:border-0">
                        <CartItem />
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="summary xs:w-full lg:w-4/12">
            <Summary />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Cart;
